export const formInitialValue = {
  section_param: "", // 截面参数
  material: "", // 材料
  construction_column: 0, // 柱-砌体选项 / 墙-类型、高度修改
  IsRingBeamSeg: 0, //是否圈梁
  sampling: 0, // 连续选择
};

//   材料类型
export const materialType = [
  { value: 1, label: "烧结砖" },
  { value: 2, label: "蒸压砖" },
  { value: 3, label: "空心砌块" },
  { value: 4, label: "混凝土砖" },

  { value: 5, label: "钢" },
  { value: 6, label: "砼" },

  { value: 10, label: "钢性材料" },
  { value: 16, label: "轻骨科" },
  { value: 17, label: "混凝土砖" },
  { value: 0, label: "无" },
  { value: 55, label: "砖" },
];

/**
 * 隔墙材料类型
 */
export const wallMaterialType = [
  { value: 51, label: "砖" },
  { value: 52, label: "玻璃" },
  { value: 53, label: "金属" },
  { value: 54, label: "轻质材料" },
  { value: 55, label: "人造板材" },
  { value: 56, label: "其他材料" },
];
/**
 * 门窗材料
 */

export const doorMaterialType = [
  { value: 53, label: "金属" },
  { value: 52, label: "玻璃" },
  { value: 54, label: "轻质材料" },
  { value: 55, label: "人造板材" },
  { value: 56, label: "其他材料" },
];

/**
 * 功能
 */
export const useFunctionType = [
  { value: 61, label: "厨房(2.0kN/m^2)" },
  { value: 62, label: "餐厅(4.0kN/m^2)" },
  { value: 63, label: "办公室(2.5kN/m^2)" },
  { value: 64, label: "健身房(4.5kN/m^2)" },
  { value: 65, label: "卫生间(2.5kN/m^2)" },
  { value: 66, label: "楼梯(3.5kN/m^2)" },
];

export const useFunctionInvestigateType = [
  { value: "房间", label: "房间" },
  { value: "客厅", label: "客厅" },
  { value: "卫生间", label: "卫生间" },
  { value: "厨房", label: "厨房" },
  { value: "梯间", label: "梯间" },
  { value: "阳台", label: "阳台" },
  { value: "楼梯", label: "楼梯" },
];

export const steelSectionType = [
  {
    value: "H型钢",
    label: "H型钢",
    imgs: "H_shaped_steel.png",
    optionList: [
      {
        label: "H150×150",
        value: "H150×150×7×10×8",
      },
      {
        label: "H175×175",
        value: "H175×175×7.5×11×13",
      },
      {
        label: "H200×150",
        value: "H200×150×8×12×13",
      },
      {
        label: "H200×200",
        value: "H200×200×8×12×13",
      },
      {
        label: "H250×250",
        value: "H250×250×9×14×13",
      },
      {
        label: "H300×200",
        value: "H300×200×8×15×13",
      },
      {
        label: "H300×300",
        value: "H300×300×10×15×13",
      },
      {
        label: "H350×250",
        value: "H350×250×9×19×13",
      },
      {
        label: "H350×350",
        value: "H350×350×12×19×13",
      },
      {
        label: "H400×400",
        value: "H400×400×13×21×22",
      },
    ],
    formItems: [
      {
        field: "H",
        title: "截面高度H(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
      {
        field: "B",
        title: "截面宽度B(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
      {
        field: "tw",
        title: "腹板厚度tw(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
      {
        field: "tf",
        title: "翼缘厚度tf(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
      {
        field: "R",
        title: "圆角半径r1(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
    ],
  },
  // {
  //   value: "方钢",
  //   label: "方钢",
  //   imgs: "square_steel.png",
  //   optionList: [
  //     {
  //       label: "□150×150×6",
  //       value: "□150×150×6",
  //     },
  //     {
  //       label: "□150×150×8",
  //       value: "□150×150×8",
  //     },
  //     {
  //       label: "□200×200×6",
  //       value: "□200×200×6",
  //     },
  //     {
  //       label: "□200×200×8",
  //       value: "□200×200×8",
  //     },
  //     {
  //       label: "□200×200×10",
  //       value: "□200×200×10",
  //     },
  //     {
  //       label: "□250×250×10",
  //       value: "□250×250×10",
  //     },
  //     {
  //       label: "□300×150×8",
  //       value: "□300×150×8",
  //     },
  //     {
  //       label: "□300×150×10",
  //       value: "□300×150×10",
  //     },
  //     {
  //       label: "□300×150×12",
  //       value: "□300×150×12",
  //     },
  //     {
  //       label: "□300×200×8",
  //       value: "□300×200×8",
  //     },
  //   ],
  //   formItems: [
  //     {
  //       field: "H",
  //       title: "截面高度H(mm)",
  //       span: 24,
  //       itemRender: {
  //         name: "VxeInput",
  //         props: {
  //           disabled: true,
  //         },
  //       },
  //     },
  //     {
  //       field: "B",
  //       title: "截面宽度B(mm)",
  //       span: 24,
  //       itemRender: {
  //         name: "VxeInput",
  //         props: {
  //           disabled: true,
  //         },
  //       },
  //     },
  //     {
  //       field: "t",
  //       title: "壁厚（各边均同）(mm)",
  //       span: 24,
  //       itemRender: {
  //         name: "VxeInput",
  //         props: {
  //           disabled: true,
  //         },
  //       },
  //     },
  //     {
  //       field: "R",
  //       title: "圆角半径R(mm)：",
  //       span: 24,
  //       itemRender: {
  //         name: "VxeInput",
  //         // props: {
  //         //   disabled: true,
  //         // },
  //       },
  //     },
  //   ],
  // },
  {
    value: "L型钢",
    label: "L型钢",
    imgs: "L_shaped_steel.png",
    optionList: [
      {
        label: "L25×16×3",
        value: "L25×16×3×5",
      },
      {
        label: "L25×16×4",
        value: "L25×16×4×5",
      },
      {
        label: "L32×20×3",
        value: "L32×20×3×5",
      },
      {
        label: "L32×20×4",
        value: "L32×20×4×5",
      },
      {
        label: "L40×25×3",
        value: "L40×25×3×5",
      },
      {
        label: "L40×25×4",
        value: "L40×25×4×5",
      },
      {
        label: "L45×28×3",
        value: "L45×28×3×5",
      },
      {
        label: "L45×28×4",
        value: "L45×28×4×5",
      },
      {
        label: "L50×32×3",
        value: "L50×32×3×5",
      },
      {
        label: "L50×32×4",
        value: "L50×32×4×5",
      },
    ],
    formItems: [
      {
        field: "B",
        title: "长边宽度B(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
      {
        field: "b",
        title: "短边宽度b(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
      {
        field: "t",
        title: "壁厚（各边均同）t(mm)",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
      {
        field: "R",
        title: "圆角半径R(mm)：",
        span: 24,
        itemRender: {
          name: "VxeInput",
          props: {
            disabled: true,
          },
        },
      },
    ],
  },
  // {
  //   value: "T型钢",
  //   label: "T型钢",
  //   imgs: "T_shaped_steel.png",
  //   optionList: [
  //     {
  //       value: "TW50×100",
  //       label: "TW50×100",
  //     },
  //     {
  //       value: "TW62.5×125",
  //       label: "TW62.5×125",
  //     },
  //     {
  //       value: "TW75×150",
  //       label: "TW75×150",
  //     },
  //     {
  //       value: "TW87.5×175",
  //       label: "TW87.5×175",
  //     },
  //     {
  //       value: "TW100×200",
  //       label: "TW100×200",
  //     },
  //     {
  //       value: "TW100×204",
  //       label: "TW100×204",
  //     },
  //     {
  //       value: "TW125×250",
  //       label: "TW125×250",
  //     },
  //     {
  //       value: "TW125×255",
  //       label: "TW125×255",
  //     },
  //     {
  //       value: "TW147×302",
  //       label: "TW147×302",
  //     },
  //     {
  //       value: "TW150×300",
  //       label: "TW150×300",
  //     },
  //   ],
  //   formItems: [
  //     {
  //       field: "H",
  //       title: "截面高度H(mm)",
  //       itemRender: {
  //         name: "VxeInput",
  //         props: {
  //           disabled: true,
  //         },
  //       },
  //       span: 24,
  //     },
  //     {
  //       field: "B",
  //       title: "截面宽度B(mm)",
  //       itemRender: {
  //         name: "VxeInput",
  //         props: {
  //           disabled: true,
  //         },
  //       },
  //       span: 24,
  //     },
  //     {
  //       field: "tw",
  //       title: "腹板厚度tw(mm)",
  //       span: 24,
  //       itemRender: {
  //         name: "VxeInput",
  //         // props: {
  //         //   disabled: true,
  //         // },
  //       },
  //     },
  //     {
  //       field: "t",
  //       title: "壁厚（各边均同）t(mm)",
  //       span: 24,
  //       itemRender: {
  //         name: "VxeInput",
  //         // props: {
  //         //   disabled: true,
  //         // },
  //       },
  //     },
  //     {
  //       field: "R",
  //       title: "圆角半径R(mm)：",
  //       span: 24,
  //       itemRender: {
  //         name: "VxeInput",
  //         // props: {
  //         //   disabled: true,
  //         // },
  //       },
  //     },
  //   ],
  // },
];
/**
 * 截面宽度(B) - 矩形
 * 截面高度(H) - 矩形
 *
 * 外接圆直径(B) - 正多边形
 * 多边形边数(N) - 正多边形
 *
 * 截面直径(B) - 圆形
 *
 * 腹板厚度(B) - 工字形
 * 截面高度(H) - 工字形
 * 上翼缘宽度(U) - 工字形
 * 上翼缘厚度(T) - 工字形
 * 下翼缘宽度(D) - 工字形
 * 下翼缘厚度(F) - 工字形
 *
 * 腹板厚度(B) - 十字工字形
 * 截面高度(H) - 十字工字形
 * 翼缘厚度(T) - 十字工字形
 * 翼缘宽度(F) - 十字工字形
 * 腹板厚度(U) - 十字工字形
 * 截面高度(D) - 十字工字形
 * 翼缘厚度(L) - 十字工字形
 * 翼缘宽度(P) - 十字工字形
 *
 * 外接圆直径(D) - 圆管
 * 圆环壁厚(T) - 圆管
 *
 * 截面总宽度(B) - 箱形
 * 截面高度(H) - 箱形
 * 上下边缘厚度(U) - 箱形
 * 左右边缘厚度(T) - 箱形
 *
 * 截面宽度(B) - L形
 * 截面高度(H) - L形
 * 翼缘宽度(D) - L形
 * 翼缘厚度(F) - L形
 * 翼缘方向(FL) - L形
 * 高度方向(FU) - L形
 *
 * 腹板厚度(B) - T形
 * 截面高度(H) - T形
 * 截面方向(FU) - T形
 * 翼缘宽度(D) - T形
 * 翼缘厚度(F) - T形
 *
 * 截面宽度(B) - 变截面(高度)
 * 左(下)端截面高度(H1) - 变截面(高度)
 * 右(上)端截面高度(H2) - 变截面(高度)
 *
 * 厚度(T) - 普通墙
 * 高度(输同层高H) - 普通墙
 *
 * 腹板厚度(B) - 槽形
 * 截面总高度(H) - 槽形
 * 上翼缘宽度(U) - 槽形
 * 上翼缘厚度(T) - 槽形
 * 下翼缘宽度(D) - 槽形
 * 下翼缘厚度(F) - 槽形
 * 下翼缘方向(FL) - 槽形
 * 上翼缘方向(FL) - 槽形
 *
 * 厚度(T) - 飘板
 * 外挑长度(L) - 飘板
 */
// construct动态下拉数据
//板option
export const plateOption = [
  { value: 100, label: 100 },
  { value: 110, label: 110 },
  { value: 120, label: 120 },
  { value: 130, label: 130 },
  { value: 140, label: 140 },
  { value: 150, label: 150 },
  { value: 160, label: 160 },
  { value: 170, label: 170 },
  { value: 180, label: 180 },
  { value: 190, label: 190 },
  { value: 200, label: 200 },
];
// 墙option
export const wallOption = [
  { value: 100, label: 100 },
  { value: 120, label: 120 },
  { value: 150, label: 150 },
  { value: 180, label: 180 },
  { value: 200, label: 200 },
  { value: 240, label: 240 },
  { value: 250, label: 250 },
  { value: 300, label: 300 },
  { value: 350, label: 350 },
  { value: 360, label: 360 },
  { value: 400, label: 400 },
];

// 200/400/600 /隔墙
export const cantiSlabWidthData = [
  { value: 0, label: 0 },
  { value: 200, label: 200 },
  { value: 250, label: 250 },
  { value: 300, label: 300 },
  { value: 350, label: 350 },
  { value: 400, label: 400 },
  { value: 450, label: 450 },
  { value: 500, label: 500 },
  { value: 550, label: 550 },
  { value: 600, label: 600 },
  { value: 650, label: 650 },
  { value: 700, label: 700 },
  { value: 750, label: 750 },
  { value: 800, label: 800 },
  { value: 850, label: 850 },
  { value: 900, label: 900 },
  { value: 950, label: 950 },
  { value: 1000, label: 1000 },
];

// 200/400/600 /隔墙
export const mockData = [
  { value: 200, label: 200 },
  { value: 250, label: 250 },
  { value: 300, label: 300 },
  { value: 350, label: 350 },
  { value: 400, label: 400 },
  { value: 450, label: 450 },
  { value: 500, label: 500 },
  { value: 550, label: 550 },
  { value: 600, label: 600 },
  { value: 650, label: 650 },
  { value: 700, label: 700 },
  { value: 750, label: 750 },
  { value: 800, label: 800 },
  { value: 850, label: 850 },
  { value: 900, label: 900 },
  { value: 950, label: 950 },
  { value: 1000, label: 1000 },
];
// 20/40/60
const numberData = [
  { value: 20, label: 20 },
  { value: 40, label: 40 },
  { value: 60, label: 60 },
  { value: 80, label: 80 },
  { value: 100, label: 100 },
  { value: 120, label: 120 },
  { value: 140, label: 140 },
  { value: 160, label: 160 },
  { value: 180, label: 180 },
  { value: 200, label: 200 },
  { value: 220, label: 220 },
  { value: 240, label: 240 },
];
// 边数下拉 5/6/7/8
const edgeNumber = [
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
];
const directionUP = [
  { value: 1, label: "上" },
  { value: 2, label: "下" },
];
const directionLeft = [
  { value: 3, label: "左" },
  { value: 4, label: "右" },
];

// 墙 - 截面参数：矩形
export const wallData = {
  id: 1, // 普通墙
  label: "矩形",
  imgs: "normal_wall.png",
  fieldKey: ["B"],
  initData: {
    material: 6,

    B: 200,
  },
  formData: [
    {
      field: "B",
      title: "厚度(B)",
      span: 24,
      itemRender: {
        pullShow: false,
        options: mockData,
        props: {
          type: "number",
        },
      },
      slots: { default: "selInp" },
    },
  ],
};
// 板 - 截面参数：矩形
export const boardData = {
  id: 1, // 普通板
  imgs: "normal_plate.png",
  fieldKey: ["T"],
  initData: {
    material: 6,
    T: 100,
  },
  formData: [
    {
      field: "T",
      title: "厚度(T)",
      span: 24,
      itemRender: {
        pullShow: false,
        options: plateOption,
        props: {
          type: "number",
        },
      },
      slots: { default: "selInp" },
    },
  ],
};
// 飘板 - 截面参数：矩形
export const waftData = {
  id: 1, // 飘板
  imgs: "floating_board.png",
  fieldKey: ["T", "L"],
  initData: {
    material: 6,
    T: 100,
    L: 400,
  },
  formData: [
    {
      field: "T",
      title: "厚度(T)",
      span: 24,
      itemRender: {
        pullShow: false,
        options: mockData,
        props: {
          type: "number",
        },
      },
      slots: { default: "selInp" },
    },
    {
      field: "L",
      title: "外挑长度(L)",
      span: 24,
      itemRender: {
        pullShow: false,
        options: mockData,
        props: {
          type: "number",
        },
      },
      slots: { default: "selInp" },
    },
  ],
};
// 墙洞 - 截面参数：矩形
export const holeData = {
  id: 1, // 矩形
  value: 1,
  label: "矩形",
  imgs: "rectangle.png",
  fieldKey: ["B", "H"],
  initData: {
    B: "200",
    H: "400",
  },
  formData: [
    {
      field: "B",
      title: "截面宽度(B)",
      span: 24,
      itemRender: {
        pullShow: false,
        options: mockData,
      },
      slots: { default: "selInp" },
    },
    {
      field: "H",
      title: "截面高度(H)",
      span: 24,
      itemRender: {
        pullShow: false,
        options: mockData,
        props: {
          type: "number",
        },
      },
      slots: { default: "selInp" },
    },
  ],
};

//墙截面
export const wallSectionData = [
  {
    id: 1, // 矩形
    value: 1,
    label: "矩形",
    imgs: "rectangle.png",
    fieldKey: ["B"],
    initData: {
      B: "120",
      material: 6,
    },
    formData: [
      {
        field: "B",
        title: "截面宽度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: wallOption,
        },
        slots: { default: "selInp" },
      },
    ],
  },
];

//悬挑板截面
export const cantiSlabSectionData = [
  {
    id: 1, // 矩形
    value: 1,
    label: "矩形",
    imgs: "rectangle.png",
    fieldKey: ["Width", "Length", "Thick"],
    initData: {
      Width: "0",
      Length: "400",
      Thick: "100",
      material: 6,
    },
    formData: [
      {
        field: "Width",
        title: "宽度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: cantiSlabWidthData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "Length",
        title: "外挑长度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      {
        field: "Thick",
        title: "板厚(T)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
    ],
  },
];

// 截面类型-构件动态表
export const constructDataList = [
  {
    id: 1, // 矩形
    value: 1,
    label: "矩形",
    imgs: "rectangle.png",
    fieldKey: ["B", "H"],
    initData: {
      B: "200",
      H: "400",
      material: 6,
    },
    formData: [
      {
        field: "B",
        title: "截面宽度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "H",
        title: "截面高度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 4, // 正多边形
    label: "正多边形",
    imgs: "regular_polygon.png",
    fieldKey: ["B", "N"],
    initData: {
      B: "400",
      N: "6",
      material: 6,
    },
    formData: [
      {
        field: "B",
        title: "外接圆直径(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "N",
        title: "多边形边数(N)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: edgeNumber,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
    ],
  },

  {
    id: 3, // 圆形
    label: "圆形",
    imgs: "circle.png",
    fieldKey: ["B"],
    initData: {
      B: "400",
      material: 6,
    },
    formData: [
      {
        field: "B",
        title: "截面直径(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 2,
    label: "工字型",
    imgs: "i_shape.png",
    fieldKey: ["B", "H", "U", "T", "D", "F"],
    initData: {
      B: 20,
      H: 600,
      U: 400,
      T: 20,
      D: 400,
      F: 20,
      material: 6,
    },
    formData: [
      {
        field: "B",
        title: "腹板厚度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "H",
        title: "截面高度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "U",
        title: "上翼缘宽度(U)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "T",
        title: "上翼缘厚度(T)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "D",
        title: "下翼缘宽度(D)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "F",
        title: "下翼缘厚度(F)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 10, // 十字工
    label: "十字工",
    imgs: "cross_shape.png",
    fieldKey: ["B", "H", "T", "F", "U", "D", "L", "P"],
    initData: {
      material: 6,
      B: 20,
      D: 600,
      F: 200,
      H: 600,
      T: 20,
      U: 20,
      L: 20,
      P: 200,
    },
    formData: [
      {
        className: "tagBox",
        span: 24,
        children: [
          {
            className: "工形1",
            itemRender: {},
            slots: { default: "selTag" },
          },
        ],
      },
      {
        field: "B",
        title: "腹板厚度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "H",
        title: "截面高度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "T",
        title: "翼缘厚度(T)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "F",
        title: "翼缘宽度(F)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        className: "tagBox",
        span: 24,
        children: [
          {
            className: "工形2",
            itemRender: {},
            slots: { default: "selTag" },
          },
        ],
      },
      {
        field: "U",
        title: "腹板厚度(U)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "D",
        title: "截面高度(D)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "L",
        title: "翼缘厚度(L)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "P",
        title: "翼缘宽度(P)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 8, // 圆管
    label: "圆管",
    imgs: "circular_tube.png",
    fieldKey: ["D", "T"],
    initData: {
      material: 6,
      D: 600,
      T: 100,
    },
    formData: [
      {
        field: "D",
        title: "外接圆直径(D)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "T",
        title: "圆环壁厚(T)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 7, // 箱形
    label: "箱形",
    imgs: "box_shape.png",
    fieldKey: ["B", "H", "U", "T"],
    initData: {
      material: 6,
      T: 20,
      B: 500,
      H: 600,
      U: 20,
    },
    formData: [
      {
        field: "B",
        title: "截面总宽度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "H",
        title: "截面高度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      {
        field: "U",
        title: "上下边缘厚度(U)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      {
        field: "T",
        title: "左右边缘厚度(T)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 28, // L形
    label: "L形",
    imgs: "l_shape.png",
    fieldKey: ["B", "H", /* "FU",*/ "D", /*"FL",*/ "F"],
    initData: {
      material: 6,
      D: 600,
      T: 20,
      B: 500,
      H: 600,
      U: 20,
      // FU: 1,
      // FL: 3,
      F: 200,
    },
    formData: [
      {
        field: "B",
        title: "截面宽度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "H",
        title: "截面高度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      // {
      //   field: "FU",
      //   title: "高度方向",
      //   span: 24,
      //   itemRender: {
      //     options: directionUP,
      //   },
      //   slots: { default: "setSel" },
      //   isFinite: true,
      // },
      {
        field: "D",
        title: "翼缘宽度(D)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      // {
      //   field: "FL",
      //   title: "翼缘方向",
      //   span: 24,
      //   itemRender: {
      //     options: directionLeft,
      //   },
      //   slots: { default: "setSel" },
      //   isFinite: true,
      // },
      {
        field: "F",
        title: "翼缘厚度(F)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 29, // T形
    label: "T形",
    imgs: "t_shape.png",
    fieldKey: ["B", "H", /*"FU",*/ "D", "F"],
    initData: {
      material: 6,
      B: 200,
      H: 600,
      D: 600,
      F: 200,
      // FU: 1,
      // FL: 3,
    },
    formData: [
      {
        field: "B",
        title: "腹板厚度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "H",
        title: "截面高度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      // {
      //   field: "FU",
      //   title: "截面方向",
      //   span: 24,
      //   itemRender: {
      //     options: directionUP,
      //   },
      //   slots: { default: "setSel" },
      //   isFinite: true,
      // },
      {
        field: "D",
        title: "翼缘宽度(D)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      {
        field: "F",
        title: "翼缘厚度(F)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 21, // 矩形变截面
    label: "矩形变截面",
    imgs: "rectangle_variable_section.png",
    fieldKey: ["B", "H1", "H2"],
    initData: {
      material: 6,
      B: 200,
      H1: 400,
      H2: 500,
    },
    formData: [
      {
        field: "B",
        title: "截面宽度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      {
        field: "H1",
        title: "左(下)端截面高度(H1)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
      {
        field: "H2",
        title: "右(上)端截面高度(H2)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
          props: {
            type: "number",
          },
        },
        slots: { default: "selInp" },
      },
    ],
  },
  {
    id: 5, // 槽形
    label: "槽形",
    imgs: "channel_shape.png",
    fieldKey: ["B", "H", "U", "T", "FL", "D", "F", "FL"],
    initData: {
      material: 6,
      D: 600,
      T: 20,
    },
    formData: [
      {
        field: "B",
        title: "腹板厚度(B)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "H",
        title: "截面总高度(H)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "U",
        title: "上翼缘宽度(U)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "T",
        title: "上翼缘厚度(T)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "FL",
        title: "上翼缘方向",
        span: 24,
        itemRender: {
          options: directionLeft,
        },
        slots: { default: "setSel" },
        isFinite: true,
      },
      {
        field: "D",
        title: "下翼缘宽度(D)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: mockData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "F",
        title: "下翼缘厚度(F)",
        span: 24,
        itemRender: {
          pullShow: false,
          options: numberData,
        },
        slots: { default: "selInp" },
      },
      {
        field: "FL",
        title: "下翼缘方向",
        span: 24,
        itemRender: {
          options: directionLeft,
        },
        slots: { default: "setSel" },
        isFinite: true,
      },
    ],
  },
  // 添加型钢
  {
    id: 26, // 型钢
    label: "型钢",
    imgs: "H_shaped_steel.png",
    fieldKey: ["B", "H1", "H2"],
    initData: {
      sectionSteelType: "H型钢",
      specifications: "H150×150×7×10×8",
      H: "150",
      B: "150",
      tw: "7",
      tf: "10",
      R: "8",
    },
    formData: [
      {
        field: "sectionSteelType",
        title: "选择型钢形式",
        span: 24,
        itemRender: {
          options: steelSectionType,
        },
        slots: { default: "setSel" },
      },
      {
        field: "specifications",
        title: "选择型钢规格",
        span: 24,
        slots: { default: "specifications" },
      },
    ],
  },
];
// 计算不同构件返回的不同矩形
export const getConstruct = (GJID) => {
  // 303:墙;304:板;306板洞;308:飘板;
  let list = JSON.parse(JSON.stringify(constructDataList));
  list[0] =
    GJID === 303 || GJID === "rlWallSeg"
      ? wallData
      : GJID === 304 || GJID === "rlSlab"
      ? boardData
      : GJID === 308
      ? waftData
      : GJID === 305
      ? holeData
      : constructDataList[0];
  return list;
};

// 获取截面数据
export const getKindType = (kind, arr) => {
  let list = arr.find((i) => i.id == kind);
  return list ? list : "kind错误";
};

// indexedDB数据转换为页面数据
export const convertShapeValToParams = (shapeVal, fieldKey, sliceNum) => {
  return new Promise((resolve) => {
    // 模拟异步操作，例如从indexedDB中获取数据
    setTimeout(() => {
      // 将字符串转换为数组
      const dataArray = shapeVal.split(",").map(Number);
      // 去掉前一个和最后两个数据
      const filteredData = dataArray.slice(1, -2);
      // 初始化params对象
      const params = {};
      const section = filteredData.join("*");
      // 将剩余的数据与字段键进行匹配
      fieldKey &&
        filteredData.forEach((value, index) => {
          const key = fieldKey[index];
          params[key] = value;
        });
      resolve({
        params,
        section,
      });
    }, 0);
  });
};

// classTypeName 模型类型筛选
export const moduleTypes = [
  {
    field: "rlAxis",
    name: "轴线",
  },
];
